import React from 'react'
import Avatar from 'components/Avatar'
import { Flex } from 'components/Box'
import ApolloErrorComponent from 'components/ApolloError'
import Panel from 'components/Panel'
import {
  Panel as StyledPanel,
  Heading,
  NameWithAvatar,
  Content,
  WordBreak,
  MainAction,
  SecondaryActionLink,
  BodyPanel,
} from './shared'
import { Inviter } from './types'
import { ParsedError } from 'graphql/apollo/useMutation'

export type UserInfo = {
  userEmail: string
  userAvatar?: string | null
}
interface AcceptMembershipPanelProps {
  inviter?: Inviter
  documentName: string
  acceptShareMembership(): void
  acceptShareMembershipError?: ParsedError
  acceptShareMembershipLoading: boolean
  userInfo: UserInfo
  onRequestAccessWithDifferentAccount?: () => void
}

const AcceptMembershipPanel = ({
  inviter,
  documentName,
  acceptShareMembership,
  acceptShareMembershipError,
  acceptShareMembershipLoading,
  userInfo,
  onRequestAccessWithDifferentAccount,
}: AcceptMembershipPanelProps) => {
  const { userEmail, userAvatar } = userInfo
  return (
    <StyledPanel>
      <BodyPanel>
        {inviter && (
          <Flex justifyContent="center">
            <Avatar
              size="64px"
              src={inviter?.avatar?.large || undefined}
              name={inviter.name || '?' /** Name should always be there */}
            />
          </Flex>
        )}
        <Heading inviter={inviter} documentName={documentName} />
        <Content>
          <WordBreak>
            Accept this invitation using{' '}
            <NameWithAvatar name={userEmail} src={userAvatar} /> to get access
            to &ldquo;<strong>{documentName}</strong>&rdquo; and be notified of
            any updates.
          </WordBreak>
        </Content>
      </BodyPanel>
      <Panel.Footer>
        {acceptShareMembershipError && (
          <ApolloErrorComponent
            style={{ textAlign: 'left' }}
            my={4}
            error={acceptShareMembershipError}
          />
        )}
        <Flex flexDirection="column" alignItems="center">
          <MainAction
            variant="primary-untinted"
            fill
            onClick={acceptShareMembership}
            loading={acceptShareMembershipLoading}>
            Accept Invitation
          </MainAction>
          {onRequestAccessWithDifferentAccount ? (
            <SecondaryActionLink
              fill
              onClick={onRequestAccessWithDifferentAccount}>
              Request access with a different email
            </SecondaryActionLink>
          ) : (
            ''
          )}
        </Flex>
      </Panel.Footer>
    </StyledPanel>
  )
}

export default AcceptMembershipPanel
